import { Droplets, Zap } from "lucide-react";

const TrustSection = () => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 items-center justify-center text-sm text-muted-foreground mt-6">
      <div className="flex items-center gap-2">
        <Droplets className="w-5 h-5 text-amethyst" />
        <span>Trusted by thousands who choose mindful hydration</span>
      </div>
      <div className="flex items-center gap-2">
        <Zap className="w-5 h-5 text-amethyst" />
        <span>100% secure checkout via SlimCrystal.com</span>
      </div>
    </div>
  );
};

export default TrustSection;
